module.exports = __webpack_public_path__ + "img/capsule-bg-image.dbcaa1ad.png";